import React from 'react';

const CustomerView = () => {
  // Mock data matching the exact 8 rows in the design
  const tableData = [
    { id: 1, initials: 'SL', name: 'Semiconductors Ltd', contact: 'Deepa Nair', email: 'deepa@semicond.in', plan: 'Premium', state: 'Karnataka', industry: 'Electronics', bids: 67, won: 28, winRate: '41.8%', wPct: 41.8, bidVol: '₹9.2 Cr', status: 'Active', joined: 'May 2024' },
    { id: 2, initials: 'TL', name: 'TechCorp Ltd', contact: 'Rahul Mehta', email: 'rahul@techcorp.in', plan: 'Premium', state: 'Karnataka', industry: 'IT Services', bids: 142, won: 52, winRate: '36.6%', wPct: 36.6, bidVol: '₹8.4 Cr', status: 'Active', joined: 'Jan 2024' },
    { id: 3, initials: 'PS', name: 'PowerGrid Systems', contact: 'Kavitha Iyer', email: 'kavitha@powergrid.in', plan: 'Advanced', state: 'Maharashtra', industry: 'Electrical', bids: 112, won: 38, winRate: '33.9%', wPct: 33.9, bidVol: '₹7.8 Cr', status: 'Active', joined: 'Feb 2024' },
    { id: 4, initials: 'BS', name: 'BuildPro Solutions', contact: 'Priya Sharma', email: 'priya@buildpro.in', plan: 'Advanced', state: 'Maharashtra', industry: 'Construction', bids: 98, won: 31, winRate: '31.6%', wPct: 31.6, bidVol: '₹6.2 Cr', status: 'Active', joined: 'Mar 2024' },
    { id: 5, initials: 'GL', name: 'Global Logistics Inc', contact: 'Anjali Singh', email: 'anjali@globallog.in', plan: 'Primary', state: 'Tamil Nadu', industry: 'Logistics', bids: 76, won: 22, winRate: '28.9%', wPct: 28.9, bidVol: '₹4.8 Cr', status: 'Active', joined: 'Feb 2024' },
    { id: 6, initials: 'MS', name: 'MedHealth Systems', contact: 'Vikram Patel', email: 'vikram@medhealth.in', plan: 'Premium', state: 'Gujarat', industry: 'Healthcare', bids: 54, won: 14, winRate: '23.9%', wPct: 23.9, bidVol: '₹3.1 Cr', status: 'Inactive', joined: 'Apr 2024' },
    { id: 7, initials: 'I', name: 'InnovateTech', contact: 'Suresh Kumar', email: 'suresh@innovate.in', plan: 'Advanced', state: 'Telangana', industry: 'IT Services', bids: 89, won: 21, winRate: '23.6%', wPct: 23.6, bidVol: '₹5.7 Cr', status: 'Active', joined: 'Jan 2024' },
    { id: 8, initials: 'AC', name: 'ABC Construction', contact: 'Mohan Reddy', email: 'mohan@abcconst.in', plan: 'Primary', state: 'Andhra Pradesh', industry: 'Construction', bids: 43, won: 8, winRate: '18.6%', wPct: 18.6, bidVol: '₹2.4 Cr', status: 'Active', joined: 'Jun 2024' },
  ];

  // Helper function to render plan badges with correct colors
  const renderPlanBadge = (plan) => {
    let bg, color;
    if (plan === 'Premium') { bg = '#f3e8ff'; color = '#7e22ce'; }
    else if (plan === 'Advanced') { bg = '#e0f2fe'; color = '#0369a1'; }
    else { bg = '#ccfbf1'; color = '#0f766e'; } // Primary
    return <span className="px-2 py-1" style={{ backgroundColor: bg, color: color, borderRadius: '12px', fontSize: '0.7rem', fontWeight: '600' }}>{plan}</span>;
  };

  // Helper function to render status badges
  const renderStatusBadge = (status) => {
    const bg = status === 'Active' ? '#dcfce7' : '#fef3c7';
    const color = status === 'Active' ? '#166534' : '#92400e';
    return <span className="px-2 py-1" style={{ backgroundColor: bg, color: color, borderRadius: '12px', fontSize: '0.7rem', fontWeight: '600' }}>{status}</span>;
  };

  return (
<div className="container-fluid py-4" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>      
      {/* Page Header */}
      <div className="mb-4">
        <h3 style={{ fontWeight: '700', color: '#111827', margin: 0 }}>Customer Hub</h3>
        <p style={{ color: '#6b7280', fontSize: '0.85rem', margin: '4px 0 0 0' }}>All Customer Overview, Tenders and Billings</p>
      </div>

      {/* Top Summary Cards */}
      <div className="row g-3 mb-4">
        {[
          { title: 'TOTAL CUSTOMERS', value: '8', subtext: 'All accounts', trend: '▲ 8% growth', trendColor: '#16a34a' },
          { title: 'ACTIVE', value: '7', subtext: 'Paying subscribers', trend: '▲ 2 new this week', trendColor: '#16a34a' },
          { title: 'PREMIUM PLANS', value: '3', subtext: 'Highest tier', trend: '', trendColor: '' },
          { title: 'AVG WIN RATE', value: '29.4%', subtext: 'Platform average', trend: '▲ 2.1% improvement', trendColor: '#16a34a' },
          { title: 'INACTIVE', value: '1', subtext: 'Needs attention', trend: '▼ Action required', trendColor: '#dc2626' },
        ].map((card, idx) => (
          <div className="col" key={idx} style={{ minWidth: '180px' }}>
            <div className="card h-100 bg-white p-3" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
              <h6 className="mb-2" style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.05em' }}>{card.title}</h6>
              <h3 className="mb-1" style={{ fontWeight: '700', color: '#111827', fontSize: '1.75rem' }}>{card.value}</h3>
              <p className="mb-3" style={{ fontSize: '0.75rem', color: '#6b7280' }}>{card.subtext}</p>
              {card.trend && (
                <p className="mb-0" style={{ fontSize: '0.75rem', color: card.trendColor, fontWeight: '600' }}>{card.trend}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Search and Filters Band */}
      <div className="card bg-white p-3 mb-4 d-flex flex-row gap-3 align-items-end flex-wrap w-100" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
        {/* Main Search Input */}
        <div style={{ flex: '2', minWidth: '300px' }}>
          <label className="mb-2 d-block" style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.02em' }}>SEARCH CUSTOMERS</label>
          <input type="text" className="form-control shadow-none w-100" placeholder="Name, email, contact..." style={{ border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.85rem', color: '#111827', height: '40px', padding: '0 1rem' }} />
        </div>
        
        {/* Select Dropdowns */}
        {['PLAN', 'STATUS', 'STATE', 'CATEGORY'].map((label, idx) => (
          <div key={idx} style={{ flex: '1', minWidth: '100px' }}>
            <label className="mb-2 d-block" style={{ fontSize: '0.65rem', fontWeight: '700', color: '#6b7280', letterSpacing: '0.02em' }}>{label}</label>
            <select className="form-select shadow-none w-100" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.85rem', color: '#4b5563', height: '40px', cursor: 'pointer' }}>
              <option>All</option>
            </select>
          </div>
        ))}

        {/* Reset Button */}
        <div>
          <button className="btn btn-white shadow-none" style={{ border: '1px solid #e5e7eb', borderRadius: '8px', fontSize: '0.8rem', color: '#4b5563', height: '40px', minWidth: '70px', padding: '0 1rem' }}>
            Reset
          </button>
        </div>
      </div>

      {/* Main Data Table */}
      <div className="card bg-white" style={{ border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
        <div className="d-flex justify-content-between align-items-center p-3" style={{ borderBottom: '1px solid #f3f4f6' }}>
          <h5 className="mb-0" style={{ fontWeight: '700', color: '#111827', fontSize: '1rem' }}>Customers (8)</h5>
          <span style={{ fontSize: '0.75rem', color: '#6b7280', cursor: 'pointer' }}>Click any row to view full profile & performance →</span>
        </div>

        <div className="table-responsive">
          <table className="table align-middle mb-0" style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
            <thead>
              <tr style={{ color: '#6b7280', fontSize: '0.65rem', fontWeight: '700', letterSpacing: '0.05em', borderBottom: '1px solid #e5e7eb' }}>
                <th className="py-3 px-4 border-bottom-0">COMPANY</th>
                <th className="border-bottom-0">EMAIL</th>
                <th className="border-bottom-0">PLAN</th>
                <th className="border-bottom-0">STATE</th>
                <th className="text-center border-bottom-0">TOTAL BIDS</th>
                <th className="text-center border-bottom-0">WON</th>
                <th className="border-bottom-0">WIN RATE</th>
                <th className="border-bottom-0">BID VOLUME</th>
                <th className="border-bottom-0">STATUS</th>
                <th className="border-bottom-0">JOINED</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row) => (
                <tr key={row.id} style={{ borderBottom: '1px solid #f3f4f6', cursor: 'pointer' }}>
                  <td className="px-4 py-3">
                    <div className="d-flex align-items-center gap-3">
                      <div className="rounded-circle d-flex justify-content-center align-items-center text-white" style={{ width: '36px', height: '36px', backgroundColor: '#0f766e', fontSize: '0.75rem', fontWeight: '600' }}>
                        {row.initials}
                      </div>
                      <div>
                        <div style={{ fontWeight: '600', color: '#111827', fontSize: '0.85rem' }}>{row.name}</div>
                        <div style={{ color: '#6b7280', fontSize: '0.75rem' }}>{row.contact}</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ color: '#6b7280' }}>{row.email}</td>
                  <td>{renderPlanBadge(row.plan)}</td>
                  <td>
                    <div style={{ fontWeight: '500', color: '#111827' }}>{row.state}</div>
                    <div style={{ color: '#6b7280', fontSize: '0.7rem' }}>{row.industry}</div>
                  </td>
                  <td className="text-center" style={{ fontWeight: '700', color: '#111827' }}>{row.bids}</td>
                  <td className="text-center" style={{ fontWeight: '700', color: '#16a34a' }}>{row.won}</td>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ width: '40px', height: '6px', backgroundColor: '#e5e7eb', borderRadius: '4px', overflow: 'hidden' }}>
                        <div style={{ width: `${row.wPct}%`, height: '100%', backgroundColor: '#16a34a', borderRadius: '4px' }}></div>
                      </div>
                      <span style={{ fontWeight: '600', color: '#16a34a', fontSize: '0.75rem' }}>{row.winRate}</span>
                    </div>
                  </td>
                  <td style={{ fontWeight: '500', color: '#111827' }}>{row.bidVol}</td>
                  <td>{renderStatusBadge(row.status)}</td>
                  <td style={{ color: '#6b7280' }}>{row.joined}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-between align-items-center p-3" style={{ borderTop: '1px solid #f3f4f6' }}>
          <span style={{ color: '#6b7280', fontSize: '0.8rem' }}>Showing 8 of 8 customers</span>
          <div className="d-flex gap-1">
            <button className="btn btn-sm shadow-none" style={{ backgroundColor: '#ccfbf1', color: '#0f766e', border: '1px solid #5eead4', fontSize: '0.8rem', fontWeight: '500', width: '32px' }}>1</button>
            <button className="btn btn-sm bg-white shadow-none" style={{ border: '1px solid #e5e7eb', color: '#4b5563', fontSize: '0.8rem', width: '32px' }}>2</button>
            <button className="btn btn-sm bg-white shadow-none" style={{ border: '1px solid #e5e7eb', color: '#4b5563', fontSize: '0.8rem', width: '32px' }}>3</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerView;